import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1b89e4b7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Your Details\n          ")
], -1));
const _hoisted_5 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_6 = {
    key: 0,
    class: "col-span-6"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Your details: *", -1));
const _hoisted_8 = {
    key: 1,
    class: "p-8 m-2 border border-gray-300 rounded-md col-span-6"
};
const _hoisted_9 = { class: "flex flex-col" };
const _hoisted_10 = {
    key: 0,
    class: "flex w-full justify-end"
};
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "name",
    class: "block text-sm font-medium text-gray-700"
}, "Name *", -1));
const _hoisted_12 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "email",
    class: "block text-sm font-medium text-gray-700 mt-4"
}, "Email *", -1));
const _hoisted_14 = {
    key: 1,
    class: "text-red-500"
};
const _hoisted_15 = { class: "col-span-6" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "phone",
    class: "block text-sm font-medium text-gray-700"
}, "Telephone number *", -1));
const _hoisted_17 = ["disabled"];
const _hoisted_18 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n              Would you like to add a secondary contact to this form? *\n            ", -1));
const _hoisted_20 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_21 = { class: "mt-4 space-y-4" };
const _hoisted_22 = { class: "flex items-start" };
const _hoisted_23 = { class: "h-5 flex items-center" };
const _hoisted_24 = ["disabled"];
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "yes",
        class: "font-medium text-gray-700"
    }, "Yes")
], -1));
const _hoisted_26 = { class: "flex items-start" };
const _hoisted_27 = { class: "h-5 flex items-center" };
const _hoisted_28 = ["disabled"];
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "no",
        class: "font-medium text-gray-700"
    }, "No")
], -1));
const _hoisted_30 = { key: 0 };
const _hoisted_31 = {
    key: 0,
    class: "col-span-6"
};
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Secondary contact details *", -1));
const _hoisted_33 = {
    key: 1,
    class: "p-8 m-2 border border-gray-300 rounded-md col-span-6"
};
const _hoisted_34 = { class: "flex flex-col" };
const _hoisted_35 = {
    key: 0,
    class: "flex w-full justify-end"
};
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "secondaryName",
    class: "block text-sm font-medium text-gray-700"
}, "Secondary contact Name *", -1));
const _hoisted_37 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "secondaryEmail",
    class: "block text-sm font-medium text-gray-700 mt-4"
}, "Secondary contact email address *", -1));
const _hoisted_39 = {
    key: 1,
    class: "text-red-500"
};
const _hoisted_40 = { class: "col-span-6 mt-4" };
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "secondaryPhone",
    class: "block text-sm font-medium text-gray-700"
}, "Secondary contact phone number *", -1));
const _hoisted_42 = ["disabled"];
const _hoisted_43 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_44 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_45 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_UserSearch = _resolveComponent("UserSearch");
    const _component_XIcon = _resolveComponent("XIcon");
    return (_ctx.formData)
        ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_5, [
                        (!_ctx.formData.name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _hoisted_7,
                                _createTextVNode(),
                                _createVNode(_component_UserSearch, {
                                    group: "HM",
                                    onUpdatedUser: _cache[0] || (_cache[0] = ($event) => (_ctx.handleUser($event, 'primary')))
                                })
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    (!_ctx.disableForm)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _createVNode(_component_XIcon, {
                                                class: "h-5 w-5 text-gray-400 hover:text-gray-800 cursor-pointer",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.handleClearUser('primary')))
                                            })
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(),
                                    _createElementVNode("div", null, [
                                        _hoisted_11,
                                        _createTextVNode(),
                                        _withDirectives(_createElementVNode("input", {
                                            id: "name-input",
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formData.name) = $event)),
                                            type: "text",
                                            name: "name",
                                            autocomplete: "name",
                                            class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: "",
                                            onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.vuelidate.formData.name.$touch()))
                                        }, null, 544), [
                                            [_vModelText, _ctx.formData.name]
                                        ]),
                                        _createTextVNode(),
                                        (_ctx.vuelidate.formData.name.$error)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "\n                  * " + _toDisplayString(_ctx.vuelidate.formData.name.$errors[0].$message), 1))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(),
                                        _hoisted_13,
                                        _createTextVNode(),
                                        _withDirectives(_createElementVNode("input", {
                                            id: "email-input",
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.formData.email) = $event)),
                                            type: "text",
                                            name: "email",
                                            class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: "",
                                            onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.vuelidate.formData.email.$touch()))
                                        }, null, 544), [
                                            [_vModelText, _ctx.formData.email]
                                        ]),
                                        _createTextVNode(),
                                        (_ctx.vuelidate.formData.email.$error)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "\n                  * " + _toDisplayString(_ctx.vuelidate.formData.email.$errors[0].$message), 1))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ])),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("input", {
                                id: "phone-input",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.formData.phone) = $event)),
                                type: "text",
                                name: "phone",
                                autocomplete: "name",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'error-border': _ctx.vuelidate.formData.phone.$error,
                                        'border-red-500': _ctx.vuelidate.formData.phone.$error,
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                    }]),
                                disabled: _ctx.disableForm,
                                onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.vuelidate.formData.phone.$touch()))
                            }, null, 42, _hoisted_17), [
                                [_vModelText, _ctx.formData.phone]
                            ]),
                            _createTextVNode(),
                            (_ctx.vuelidate.formData.phone.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "\n              * " + _toDisplayString(_ctx.vuelidate.formData.phone.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("fieldset", null, [
                            _hoisted_19,
                            _createTextVNode(),
                            (_ctx.vuelidate.formData.secondary.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "\n              * " + _toDisplayString(_ctx.vuelidate.formData.secondary.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "radio-button-replacement-role",
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.formData.secondary) = $event)),
                                            value: "yes",
                                            name: "yes",
                                            type: "radio",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                                }]),
                                            disabled: _ctx.disableForm,
                                            onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.vuelidate.formData.secondary.$touch()))
                                        }, null, 42, _hoisted_24), [
                                            [_vModelRadio, _ctx.formData.secondary]
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_25
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("div", _hoisted_27, [
                                            _withDirectives(_createElementVNode("input", {
                                                id: "radio-button-candidates",
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.formData.secondary) = $event)),
                                                value: "No",
                                                name: "no",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                                    }]),
                                                disabled: _ctx.disableForm
                                            }, null, 10, _hoisted_28), [
                                                [_vModelRadio, _ctx.formData.secondary]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_29
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.formData.secondary === 'yes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            (!_ctx.formData.secondaryName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _hoisted_32,
                                    _createTextVNode(),
                                    _createVNode(_component_UserSearch, {
                                        group: "ALL",
                                        onUpdatedUser: _cache[11] || (_cache[11] = ($event) => (_ctx.handleUser($event, 'secondary')))
                                    })
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, [
                                        (!_ctx.disableForm)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                _createVNode(_component_XIcon, {
                                                    class: "h-5 w-5 text-gray-400 hover:text-gray-800 cursor-pointer",
                                                    onClick: _cache[12] || (_cache[12] = ($event) => (_ctx.handleClearUser('secondary')))
                                                })
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(),
                                        _createElementVNode("div", null, [
                                            _hoisted_36,
                                            _createTextVNode(),
                                            _withDirectives(_createElementVNode("input", {
                                                id: "phone-input",
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.formData.secondaryName) = $event)),
                                                type: "text",
                                                name: "secondaryName",
                                                autocomplete: "name",
                                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                                disabled: "",
                                                onBlur: _cache[14] || (_cache[14] = ($event) => (_ctx.vuelidate.formData.secondaryName.$touch()))
                                            }, null, 544), [
                                                [_vModelText, _ctx.formData.secondaryName]
                                            ]),
                                            _createTextVNode(),
                                            (_ctx.vuelidate.formData.secondaryName.$error)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, "\n                  * " + _toDisplayString(_ctx.vuelidate.formData.secondaryName.$errors[0].$message), 1))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(),
                                            _hoisted_38,
                                            _createTextVNode(),
                                            _withDirectives(_createElementVNode("input", {
                                                id: "phone-input",
                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.formData.secondaryEmail) = $event)),
                                                type: "text",
                                                name: "secondaryEmail",
                                                autocomplete: "name",
                                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                                disabled: "",
                                                onBlur: _cache[16] || (_cache[16] = ($event) => (_ctx.vuelidate.formData.secondaryEmail.$touch()))
                                            }, null, 544), [
                                                [_vModelText, _ctx.formData.secondaryEmail]
                                            ]),
                                            _createTextVNode(),
                                            (_ctx.vuelidate.formData.secondaryEmail.$error)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_39, "\n                  * " + _toDisplayString(_ctx.vuelidate.formData.secondaryEmail.$errors[0].$message), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_40, [
                                _hoisted_41,
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("input", {
                                    id: "phone-input",
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.formData.secondaryPhone) = $event)),
                                    type: "text",
                                    name: "secondaryPhone",
                                    autocomplete: "name",
                                    class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                            'error-border': _ctx.vuelidate.formData.secondaryPhone.$error,
                                            'border-red-500': _ctx.vuelidate.formData.secondaryPhone.$error,
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        }]),
                                    disabled: _ctx.disableForm,
                                    onBlur: _cache[18] || (_cache[18] = ($event) => (_ctx.vuelidate.formData.secondaryPhone.$touch()))
                                }, null, 42, _hoisted_42), [
                                    [_vModelText, _ctx.formData.secondaryPhone]
                                ]),
                                _createTextVNode(),
                                (_ctx.vuelidate.formData.secondaryPhone.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, "\n              * " + _toDisplayString(_ctx.vuelidate.formData.secondaryPhone.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                (!_ctx.disableForm)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createElementVNode("button", {
                            disabled: _ctx.vuelidate.$invalid,
                            type: "submit",
                            class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                            onClick: _cache[19] || (_cache[19] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"]))
                        }, "\n          Save\n        ", 8, _hoisted_45)
                    ]))
                    : _createCommentVNode("", true)
            ])
        ]))
        : _createCommentVNode("", true);
}
